import { Component } from '@angular/core';

@Component({
    selector: 'ssf-close-button',
    template: require('./close-button.component.html'),
    styles: [require('./close-button.component.scss')]
})
export class CloseButtonComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/close-button/close-button.component.ts